export default __webpack_public_path__ + "static/media/IMG_034bw.3c52415c.jpg";